import React from 'react'
import { NavLink } from 'react-router-dom';
function Nav() {
    return (
        <div>
            <nav className="nav-main mainmenu-nav d-none d-xl-block">
                <ul className="mainmenu">
                    <li>
                        <NavLink className="nav-item" to={'/'} end>
                            ACCUEIL
                        </NavLink>
                    </li>
                    <li>
                        <NavLink className="nav-item" to={'/qui-sommes-nous'}>
                            QUI SOMMES-NOUS
                        </NavLink>
                    </li>
                    <li>
                        <NavLink className="nav-item" to={'/our-service'}>
                            NOS SERVICES
                        </NavLink>
                    </li>
                    <li>
                        <NavLink className="nav-item" to={'/contactus'}>
                            CONTACTEZ-NOUS
                        </NavLink>
                    </li>
                </ul>
            </nav>
        </div>
    )
}

export default Nav